import { render, staticRenderFns } from "./FilterTab.vue?vue&type=template&id=1c96c3ca&scoped=true"
import script from "./FilterTab.vue?vue&type=script&lang=js"
export * from "./FilterTab.vue?vue&type=script&lang=js"
import style0 from "./FilterTab.vue?vue&type=style&index=0&id=1c96c3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96c3ca",
  null
  
)

export default component.exports